import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-groups-modal',
  templateUrl: './groups-modal.component.html',
  styleUrls: ['./groups-modal.component.scss']
})
export class GroupsModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  groups = null;
  mode = null;
  data = null
  Success = null


  groupForm = new FormGroup({
    name: new FormControl('', Validators.required),
    short_name: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
  });

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      name,
      short_name,
      id,
    } = this.groupForm.value;
    this.auth
      .postGroups(
        name,
        short_name,
        id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });           }
          else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {

    this.auth
      .getGroups()
      .subscribe(
        (resSuccess) => {

          this.groups = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }

  addNew() {
    this.mode = "add"
  }
  edit(group) {
    this.mode = "edit"
    this.groupForm.patchValue({
      name: group.name,
      short_name: group.short_name,
      id: group.id ,
    });
    console.log(this.groupForm.value)
  }

  delete(title) {
    this.auth
      .delSet("/api/groups/deletegroup", title.id)
      .subscribe(
        (resSuccess) => {
          this.groups = this.groups.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
